<template>
    <v-card
            min-width="1200"
            class="mt-2"
            elevation="0"
    >
        <v-toolbar
                color="indigo"
                dark
                dense fixed>
            <v-card-title>
                Customize First term gold drop graph
            </v-card-title>
            <v-btn
                    class="ma-2"
                    color="success"
                    @click="DoSave()"
            >
                <v-icon
                        left
                >
                    mdi-content-save
                </v-icon>
                Save
            </v-btn>

            <v-btn
                    class="ma-2"
                    color="blue"
                    @click="DoPush()"
            >
                Push Saved to {{this.$store.state.ugsSetting.environmentName}}
            </v-btn>

            <v-btn
                    class="ma-2"
                    color="orange"
                    @click="DoReset()"
            >
                Reset last saved
            </v-btn>

            <v-btn
                    class="ma-2"
                    color="cancel"
                    @click="DoLoadDefault()"
            >
                Reset Default
            </v-btn>

            <v-spacer></v-spacer>
        </v-toolbar>
        <v-row>
            <v-subheader><strong>Graph Position</strong></v-subheader>
            <v-col>
                <v-subheader>Horizontal(x)</v-subheader>
                <v-card-text class="py-0">
                    <v-slider
                            dense
                            v-model="inputPayload.startPoint"
                            @change="onInputChanged"
                            track-color="grey"
                            thumb-label
                            min="0"
                            max="100"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="inputPayload.startPoint"
                                    @input="onInputChanged"
                                    style="width: 50px"
                                    dense
                                    type="number"
                                    min="0"
                                    max="100"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-card-text>
            </v-col>
            <v-col>
                <v-subheader>Vertical(y)</v-subheader>
                <v-card-text class="py-0">
                    <v-slider
                            dense
                            v-model="inputPayload.lineRefDiff"
                            @change="onInputChanged"
                            track-color="grey"
                            thumb-label
                            min="0"
                            max="1"
                            step="0.01"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="inputPayload.lineRefDiff"
                                    @input="onInputChanged"
                                    style="width: 50px"
                                    dense
                                    type="number"
                                    min="0"
                                    max="1"
                                    step="0.01"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-card-text>
            </v-col>
            <v-col>
                <v-subheader>Frequency</v-subheader>
                <v-card-text class="py-0">
                    <v-slider
                            dense
                            v-model="inputPayload.lengthFreq"
                            @change="onInputChanged"
                            track-color="grey"
                            thumb-label
                            min="2"
                            max="30"
                            step="0.01"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="inputPayload.lengthFreq"
                                    @input="onInputChanged"
                                    style="width: 50px"
                                    dense
                                    type="number"
                                    step="0.01"
                                    min="2"
                                    max="30"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-card-text>
            </v-col>
            <v-col>
                <v-subheader>Max Y 1K</v-subheader>
                <v-card-text class="py-0">
                    <v-slider
                            dense
                            v-model="inputPayload.maxFreqLine1k"
                            @change="onInputChanged"
                            track-color="grey"
                            thumb-label
                            min="1"
                            max="10"
                            step="0.01"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="inputPayload.maxFreqLine1k"
                                    @input="onInputChanged"
                                    style="width: 50px"
                                    dense
                                    type="number"
                                    step="0.01"
                                    min="1"
                                    max="10"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-card-text>
            </v-col>
            <v-col>
                <v-subheader>Max Y 10K</v-subheader>
                <v-card-text class="py-0">
                    <v-slider
                            dense
                            v-model="inputPayload.maxFreqLine10k"
                            @change="onInputChanged"
                            track-color="grey"
                            thumb-label
                            min="1"
                            max="10"
                            step="0.01"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="inputPayload.maxFreqLine10k"
                                    @input="onInputChanged"
                                    style="width: 50px"
                                    dense
                                    type="number"
                                    step="0.01"
                                    min="1"
                                    max="10"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-card-text>
            </v-col>
        </v-row>
        <v-row>
            <v-subheader><strong>Under 100 levels</strong></v-subheader>
            <v-col>
                <v-subheader>Base first term U100</v-subheader>
                <v-card-text class="py-0">
                    <v-slider
                            dense
                            v-model="inputPayload.startLineRefU100"
                            @change="onInputChanged"
                            track-color="grey"
                            thumb-label
                            min="0"
                            max="4"
                            step="0.01"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="inputPayload.startLineRefU100"
                                    @input="onInputChanged"
                                    style="width: 50px"
                                    dense
                                    type="number"
                                    min="0"
                                    max="4"
                                    step="0.01"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-card-text>
            </v-col>
            <v-col>
                <v-subheader>First term variance U100</v-subheader>
                <v-card-text class="py-0">
                    <v-slider
                            dense
                            v-model="inputPayload.freqFirst100Level"
                            @change="onInputChanged"
                            track-color="grey"
                            thumb-label
                            min="0"
                            max="2"
                            step="0.01"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="inputPayload.freqFirst100Level"
                                    @input="onInputChanged"
                                    style="width: 50px"
                                    dense
                                    type="number"
                                    min="0"
                                    max="2"
                                    step="0.01"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-card-text>
            </v-col>
        </v-row>
        <v-row>
    </v-row>
        <v-row>
            <v-subheader><strong>After 100 levels</strong></v-subheader>
            <v-col>
                <v-subheader>Base first term</v-subheader>
                <v-card-text class="py-0">
                    <v-slider
                            dense
                            v-model="inputPayload.startLineRef"
                            @change="onInputChanged"
                            track-color="grey"
                            thumb-label
                            min="1"
                            max="7"
                            step="0.01"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="inputPayload.startLineRef"
                                    @input="onInputChanged"
                                    style="width: 50px"
                                    dense
                                    type="number"
                                    min="1"
                                    max="7"
                                    step="0.01"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-card-text>
            </v-col>
            <v-col>
                <v-subheader>First term variance</v-subheader>
                <v-card-text class="py-0">
                    <v-slider
                            dense
                            v-model="inputPayload.startFreq"
                            @change="onInputChanged"
                            track-color="grey"
                            thumb-label
                            min="0"
                            max="2"
                            step="0.01"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="inputPayload.startFreq"
                                    @input="onInputChanged"
                                    style="width: 50px"
                                    dense
                                    type="number"
                                    min="0"
                                    max="2"
                                    step="0.01"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-card-text>
            </v-col>
            <v-col>
                <v-subheader>Variance grow step</v-subheader>
                <v-card-text class="py-0">
                    <v-slider
                            dense
                            v-model="inputPayload.diffFreq"
                            @change="onInputChanged"
                            track-color="grey"
                            thumb-label
                            min="0.01"
                            max="1"
                            step="0.01"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="inputPayload.diffFreq"
                                    @input="onInputChanged"
                                    style="width: 50px"
                                    dense
                                    type="number"
                                    min="0.01"
                                    max="1"
                                    step="0.01"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-card-text>
            </v-col>
            <v-col>
                <v-subheader>Max first term variance</v-subheader>
                <v-card-text class="py-0">
                    <v-slider
                            dense
                            v-model="inputPayload.maxFreq"
                            @change="onInputChanged"
                            track-color="grey"
                            thumb-label
                            min="0"
                            max="10"
                            step="0.01"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="inputPayload.maxFreq"
                                    @input="onInputChanged"
                                    style="width: 50px"
                                    dense
                                    type="number"
                                    min="0"
                                    max="10"
                                    step="0.01"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-card-text>
            </v-col>
            <v-col>
                <v-subheader>Grow interval(level)</v-subheader>
                <v-card-text class="py-0">
                    <v-slider
                            dense
                            v-model="inputPayload.levelPerDiffFreq"
                            @change="onInputChanged"
                            track-color="grey"
                            thumb-label
                            min="10"
                            max="1000"
                            step="10"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="inputPayload.levelPerDiffFreq"
                                    @input="onInputChanged"
                                    style="width: 50px"
                                    dense
                                    type="number"
                                    min="10"
                                    max="1000"
                                    step="10"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-card-text>
            </v-col>
        </v-row>
        <v-row>
            <v-subheader><strong>Graph Preview config</strong></v-subheader>
            <v-col>
                <v-subheader>Level Scale Reference</v-subheader>
                <v-card-text class="py-0">
                    <v-slider
                            dense
                            v-model="scaleRef"
                            @change="onInputChanged"
                            track-color="grey"
                            thumb-label
                            min="100"
                            max="10000"
                    >
                        <template v-slot:append>
                            <v-text-field
                                    v-model="scaleRef"
                                    @input="onInputChanged"
                                    style="width: 50px"
                                    dense
                                    type="number"
                                    min="100"
                                    max="10000"
                            ></v-text-field>
                        </template>
                    </v-slider>
                </v-card-text>
            </v-col>
        </v-row>
        <v-container>
            <SineWave
                    :width="1200"
                    :height="150"
                    :inputPayload="inputPayload"
                    :baseScale="scaleRef"
            />
        </v-container>
        <v-overlay :value="isLoading">
            <v-progress-circular
                    indeterminate
                    size="64"
            ></v-progress-circular>
        </v-overlay>
        <PopupMessage v-if="messageAlert!==''"
                      :pColor="messageColor"
                      :pTimeout="600"
                      @onClose="messageAlert=''"
        >
            {{messageAlert}}
        </PopupMessage>
    </v-card>
</template>

<script>
    import SineWave from './SineWave.vue';
    import GoldDropFirstTermCustomConfigLoader from "../../../dao/GoldDropFirstTermCustomConfigLoader";
    import lodash from 'lodash';
    import UnityServiceApi from '@/unity-service-dashboard/api/UnityServiceApi';
    import PopupMessage from "@/item-editor/modules/PopupMessage/PopupMessage";

    export default {
        components: {
            SineWave,
            PopupMessage
        },
        data() {
            return {
                isLoading: false,
                messageAlert: '',
                messageColor: 'orange',

                inputPayload: {
                    startLineRef: 2.5,
                    lengthFreq: 15.915494309,
                    lineRefDiff: 0.8,
                    startPoint: 0,
                    startLineRefU100: 2,
                    freqFirst100Level: 0.5,
                    maxFreq: 2.5,
                    startFreq: 1.1,
                    diffFreq: 0.175,
                    levelPerDiffFreq: 100,
                    maxFreqLine1k: 6.9,
                    maxFreqLine10k: 8.25,
                },
                scaleRef: 1200,
            };
        },
        methods:{

            async init(){
                this.isLoading = true;
                this.inputPayload = lodash.cloneDeep(this.$store.state.goldDropCustomConfig);
                this.isLoading = false;
            },

            onInputChanged(){

            },

            async DoSave(){
                if (confirm(`Are you sure you want to save config?`)) {
                    this.isLoading = true;
                    this.$store.commit(this.$store.state.commitActions.UPDATE_GOld_DROP_CUSTOM, lodash.cloneDeep(this.inputPayload));
                    await GoldDropFirstTermCustomConfigLoader.pushData(this.$store.state.goldDropCustomConfig);
                    this.setAlertMessage("Save Success", false);
                    this.isLoading = false;
                }
            },

            DoReset(){
                if (confirm('Are you sure you want to reset config from Last saved?')) {
                    this.init();
                    this.setAlertMessage("Reset to last Success", false);
                }
            },

            async DoPush(){
                let envName = this.$store.state.ugsSetting.environmentName;
                if (confirm(`Are you sure you want to push config to UGS in environment Name: ${envName}?`)) {
                    this.isLoading = true;
                    UnityServiceApi.updateRemoteConfig(this.$store.state.goldDropCustomConfig, 'goldDropCustomConfig', this.$store.state.ugsSetting.environmentId)
                        .then(result => {
                            this.setAlertMessage(result.data.message, result.data.status !== 200);
                            setTimeout(() => {
                                this.isLoading = false;
                            }, 1500);

                        })
                        .catch(error => {
                            this.setAlertMessage('Failed to add remote config: '+error, true);
                            setTimeout(() => {
                                this.isLoading = false;
                            }, 200);
                        });
                }
            },

            async DoLoadDefault(){
                if (confirm('Are you sure you want to reset config from Default, and Saved?')) {
                    let data = GoldDropFirstTermCustomConfigLoader.loadDefaultData();
                    this.$store.commit(this.$store.state.commitActions.UPDATE_GOld_DROP_CUSTOM, data);
                    await GoldDropFirstTermCustomConfigLoader.pushData(this.$store.state.goldDropCustomConfig);
                    this.init();
                    this.setAlertMessage("Reset to Default Success", false);
                }
            },

            setAlertMessage(msg, isError){
                this.messageAlert = msg;
                if(isError){
                    this.messageColor = "red";
                } else {
                    this.messageColor = "success";
                }
            }
        },
        computed: {

        },
        created() {
            this.init();
        }
    };
</script>